import LockClockOutlinedIcon from "@mui/icons-material/LockClockOutlined";

/**
 * Shown when a self-send link is opened before it goes live. The link is valid — it just hasn't gone
 * live yet — so this names the go-live date when there is one (a scheduled campaign), or a generic
 * "check back later" when there isn't (a universal link whose campaign hasn't launched yet:
 * activationDate is null), rather than the generic invalid-link message.
 */
export default function RedemptionNotYetActive({
  activationDate,
}: {
  activationDate: string | null;
}) {
  const parsed = activationDate ? new Date(activationDate) : null;
  const when =
    !parsed || Number.isNaN(parsed.getTime())
      ? null
      : parsed.toLocaleDateString(undefined, {
          weekday: "long",
          day: "numeric",
          month: "long",
          year: "numeric",
        });

  return (
    <main className="fixed inset-0 flex items-center justify-center bg-light-dust p-6">
      <div className="max-w-md text-center">
        <div
          className="mx-auto mb-5 flex h-16 w-16 items-center justify-center rounded-full"
          style={{ background: "var(--color-clear-dust)" }}
          aria-hidden="true"
        >
          <LockClockOutlinedIcon sx={{ fontSize: 30, color: "var(--color-dark-dust)" }} />
        </div>
        <h1 className="m-0 mb-2 font-crimson text-[26px] font-semibold text-rodeo-black">
          This gift isn't active yet
        </h1>
        <p className="m-0 font-lato text-[15px] leading-relaxed text-graphite">
          {when
            ? `Your gift link goes live on ${when}. Check back then to choose your gift.`
            : "Your gift link isn't live yet. Please check back a little later to choose your gift."}
        </p>
      </div>
    </main>
  );
}
